export default __webpack_public_path__ + "static/media/Convention_Center_title_rollover.0b1fdada.svg";